import { JSX } from "react";
import { InfoOutlined } from "@mui/icons-material";
import {
  Chip,
  ChipOwnProps,
  SxProps,
  Tooltip,
  TooltipProps,
  Typography,
} from "@mui/material";

const InfoChip = ({
  sx,
  info,
  label,
  icon = <InfoOutlined />,
  size = "small",
  color = "primary",
  variant = "filled",
  placement = "bottom",
}: {
  sx?: SxProps;
  size?: ChipOwnProps["size"];
  icon?: JSX.Element;
  info?: string | number;
  label?: string | JSX.Element;
  color?: ChipOwnProps["color"];
  variant?: ChipOwnProps["variant"];
  placement?: TooltipProps["placement"];
}) => (
  <Tooltip
    title={
      <Typography fontSize={11} sx={{ whiteSpace: "pre-line" }}>
        {info}
      </Typography>
    }
    placement={placement}
    sx={sx}
    slotProps={{
      tooltip: {
        sx: {
          padding: "10px",
          maxWidth: "600px",
          width: "max-content", // width adjusts to content up to maxWidth
        },
      },
    }}
  >
    {label ? (
      <Chip
        icon={icon}
        size={size}
        color={color}
        label={label}
        variant={variant}
      />
    ) : (
      <InfoOutlined fontSize={size} sx={sx} />
    )}
  </Tooltip>
);

export default InfoChip;
